import { Component, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-chat-header-thread',
  imports: [TranslatePipe, IconButtonComponent, IconComponent],
  template: `
    <rt-icon-button
      iconName="arrow-back"
      size="small"
      variant="plain"
      (click)="back.emit($event)"
    />
    <span layout layout-align-items-center text-semi-medium>
      {{ 'tlc.hr_assistant.your_thread' | translate }}
      <rt-icon margin-left-small-x name="edit-square" />
    </span>
    <rt-icon-button iconName="close" size="small" variant="plain" (click)="close.emit($event)" />
  `,
  styleUrls: ['./header-thread.component.less'],
})
export class HeaderThreadComponent {
  public close = output<MouseEvent>();
  public back = output<MouseEvent>();
}
